var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('CoachAdminTable',{attrs:{"coach-admins":_vm.coachAdmins}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }